import { useTranslation } from '@dukanti/shared';

/**
 * Keyboard-only skip-link — renders as the first focusable element inside
 * the admin shell so keyboard users can Tab once and jump straight to the
 * <main id="main"> landmark, bypassing the sidebar and top-bar.
 *
 * The visual treatment uses `sr-only` by default and reveals only on
 * focus, matching the convention used by the existing shell header.
 * Positioning uses logical Tailwind props (`start-4`) so the link appears
 * on the content-start edge regardless of RTL direction.
 */
export function AdminShellSkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main"
      data-testid="admin-shell-skip-link"
      className="focus:rounded-input focus:bg-olive focus:text-paper sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-50 focus:px-4 focus:py-2 focus:shadow-md"
    >
      {t('admin.nav.skipToContent')}
    </a>
  );
}
